module.exports = __webpack_public_path__ + "img/logo.0d0249a4.png";